class CollectionAttributeSidebar {
  constructor(collectionTags) {
    this._collectionTagsGlobal = collectionTags; // Tags for the current collection, defined in the collection-attribute-sidebar.liquid snippet
    this._collectionTags = [];
    this._filterCollectionTags = []; // Tags for the current collection, if fitlers are applied
    this._filterData = {};
    this._priceData = [];
    this._appliedFilters = [];
    this._productsToRemove = [];
    this._currentSortBy = {
      optionValue: "default",
      dataSort: "default",
    };
    this._currentPaginationState = {
      paginationIsVisible: true,
      paginationWrapper: null,
    };
    this._hasFitment = false;
    this._currentFitment = null;
    this._isTier2Selected = false;
    this._tagsContainer = document.getElementById("tags");
    this.initData(this._collectionTagsGlobal);
    this.bindEvents();
    this.loadFiltersFromSession();
  }

  // Getters and setters
  get classState() {
    return {
      collectionTags: this._collectionTags,
      filterData: this._filterData,
      priceData: this._priceData,
      appliedFilters: this._appliedFilters,
      currentSortBy: this._currentSortBy,
      hasFitment: this._hasFitment,
      currentFitment: this._currentFitment,
      isTier2Selected: this._isTier2Selected,
    };
  }

  getState() {
    return this.classState;
  }

  static openFilterSidebar() {
    document.getElementById("collection-attribute-sidebar").style.width =
      "350px";
  }

  openSidebar() {
    document.getElementById("collection-attribute-sidebar").style.width =
      "350px";
  }

  closeSidebar() {
    const sidebar = document.getElementById("collection-attribute-sidebar");
    sidebar.style.width = "0";
    if (sidebar.classList.contains("filter-sidebar-open")) {
      sidebar.classList.remove("filter-sidebar-open");
    }
  }

  async initData(collectionTagsArg) {
    const fitmentData = localStorage.getItem("fitmentData");
    const parsedFitmentData = fitmentData ? JSON.parse(fitmentData) : null;
    this._hasFitment =
      parsedFitmentData &&
      Object.keys(parsedFitmentData.currentVehicle || {}).length > 0;
    this._currentFitment = this._hasFitment
      ? parsedFitmentData.currentVehicle
      : null;
    this._collectionTags = collectionTagsArg;
    const tags = this._collectionTags;
    const tagsContainer = this._tagsContainer;

    // Create Category section first
    const categorySection = this.createCollapsibleSection("Category", true);
    const categorySectionContent =
      categorySection.querySelector("#category-content");
    tagsContainer.appendChild(categorySection);

    this.processTags(tags, categorySectionContent, tagsContainer);

    // Check current state and log
    console.log("Current state: ", this.getState());
  }

  processTags(tags, categorySectionContent, tagsContainer) {
    // Process Tier2 tags for the Category section
    tags
      .filter((tag) => tag.toLowerCase().startsWith("tier2:"))
      .forEach((tag) => {
        const [, filterValue] = tag.split(":");
        // Skip the "Lift Kits" tag
        if (filterValue.toLowerCase() === " lift kits") return;
        this.createFilterElements(
          categorySectionContent,
          "Tier2",
          filterValue,
          "tier2"
        );
      });

    tags
      .filter((tag) => tag.toLowerCase().startsWith("tier3:"))
      .forEach((tag) => {
        const [, filterValue] = tag.split(":");
        this.createFilterElements(
          categorySectionContent,
          "Tier3",
          filterValue,
          "tier3"
        );
      });

    // Process other tags
    tags.forEach((tag) => {
      if (
        tag.includes(":") &&
        !tag.toLowerCase().startsWith("tier2:") &&
        !tag.toLowerCase().startsWith("tier3:") &&
        !tag.toLowerCase().includes("price") &&
        tag.toLowerCase() !== "tier2: Lift Kits" &&
        tag.toLowerCase() !== "Lift Kits"
      ) {
        const [filterType, filterValue] = tag.split(":");
        const transformedFilterType = this.toTitleCase(filterType);

        if (!this._filterData[transformedFilterType]) {
          this._filterData[transformedFilterType] = [];
        }

        this._filterData[transformedFilterType].push(filterValue);
      } else if (tag.toLowerCase().includes("price")) {
        const [, filterValue] = tag.split(":");
        this._priceData.push(Number(filterValue));
      }
    });

    // Create facet filter sections
    for (const [filterType, filterValues] of Object.entries(
      this._filterData
    ).filter(([_, filterValues]) => filterValues.length > 1)) {
      const filterSection = this.createCollapsibleSection(filterType);
      tagsContainer.appendChild(filterSection);

      const contentDiv = filterSection.querySelector(".filter-content");
      filterValues.sort().forEach((filterValue, index) => {
        this.createFilterElements(contentDiv, filterType, filterValue, index);
      });
    }

    // Sort Filters
    const filterSections = document.querySelectorAll(".filter-content");

    function sortAlphaNumeric(a, b) {
      const aText = a.querySelector("label").innerText;
      const bText = b.querySelector("label").innerText;

      const aNum = parseFloat(aText);
      const bNum = parseFloat(bText);

      if (!isNaN(aNum) && !isNaN(bNum)) {
        return aNum - bNum;
      } else {
        return aText.localeCompare(bText, undefined, { numeric: true });
      }
    }

    for (const filterSection of Array.from(filterSections)) {
      const filterSectionChildren = Array.from(filterSection.children);
      filterSectionChildren.sort(sortAlphaNumeric);
      filterSectionChildren.forEach((child) => {
        filterSection.appendChild(child);
      });
    }
  }

  createFilterElements(container, filterType, filterValue, index) {
    if (filterType === "Tier2") {
      // Handle category-specific logic for tier2 filterType
      return this.createCategoryFilterElements(
        container,
        filterType,
        filterValue,
        index
      );
    }

    const filterValueDiv = document.createElement("div");

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.id = filterValue + index;
    checkbox.name = filterType;
    checkbox.value = filterValue;
    checkbox.classList.add("filter-checkbox", "collection-filters__item");

    // Adding data attributes for filterType and filterValue
    checkbox.setAttribute("data-filter-type", filterType);
    checkbox.setAttribute("data-filter-value", filterValue);

    const label = document.createElement("label");
    label.htmlFor = checkbox.id;
    label.innerText = filterValue;
    label.classList.add("filter-checkbox-label");

    filterValueDiv.appendChild(checkbox);
    filterValueDiv.appendChild(label);

    container.appendChild(filterValueDiv);
  }

  createCategoryFilterElements(container, filterType, filterValue, index) {
    // Custom logic for category filters (i.e., tier2 tags)
    const filterValueDiv = document.createElement("div");

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.id = filterValue + index;
    checkbox.name = filterType;
    checkbox.value = filterValue;
    checkbox.classList.add("filter-checkbox", "collection-filters__item");

    // Adding data attributes for the Category section
    checkbox.setAttribute("data-filter-type", filterType);
    checkbox.setAttribute("data-filter-value", filterValue);

    const label = document.createElement("label");
    label.htmlFor = checkbox.id;
    label.innerText = filterValue;
    label.classList.add("filter-checkbox-label");

    filterValueDiv.appendChild(checkbox);
    filterValueDiv.appendChild(label);

    container.appendChild(filterValueDiv);
  }

  createCollapsibleSection(filterType, isCategorySection = false) {
    const sectionDiv = document.createElement("div");
    sectionDiv.className = "filter-section";

    const headerDiv = document.createElement("div");
    headerDiv.className = "filter-header";
    headerDiv.innerText = isCategorySection
      ? "Category"
      : this.toTitleCase(
          filterType.toLowerCase().includes("length")
            ? filterType + " (IN)"
            : filterType
        );

    const contentDiv = document.createElement("div");
    contentDiv.className = "filter-content";

    if (isCategorySection) {
      contentDiv.id = "category-content";
    }

    sectionDiv.appendChild(headerDiv);
    sectionDiv.appendChild(contentDiv);

    headerDiv.addEventListener("click", () => {
      const contentDiv = sectionDiv.querySelector(".filter-content");
      contentDiv.classList.toggle("show");
      headerDiv.classList.toggle("active");
    });

    return sectionDiv;
  }

  async resetAndRebuildFilters(collectionTagsArg) {
    // Step 1: Reset filters
    const tagsContainer = this._tagsContainer;
    this._filterData = {}; // Clear existing filter data
    tagsContainer.innerHTML = ""; // Clear existing filters

    // Step 2: Rebuild filters
    await this.initData(collectionTagsArg);

    // Step 3: Bind facet events
    this.bindCheckboxEvents();
    this.setAppliedFacetFiltersChecked();
  }

  bindEvents() {
    document
      .getElementById("open-sidebar")
      .addEventListener("click", () => this.openSidebar());
    document
      .getElementById("close-sidebar")
      .addEventListener("click", () => this.closeSidebar());
    window.addEventListener("click", (event) => {
      const sidebar = document.getElementById("collection-attribute-sidebar");
      const openButton = document.getElementById("open-sidebar");

      if (
        !sidebar.contains(event.target) &&
        event.target !== openButton &&
        !sidebar.classList.contains("filter-sidebar-open")
      ) {
        this.closeSidebar();
      }
    });
    this.bindCheckboxEvents();

    document
      .getElementById("clear-all-filters")
      .addEventListener("click", () => this.clearAllFilters());
  }

  handleFilterChange(event) {
    const filterType = event.target.name;
    const filterValue = event.target.value;

    if (event.target.checked) {
      this.addFilter(filterType, filterValue);
    } else {
      this.removeFilter(filterType, filterValue);
    }

    if (this._appliedFilters.length > 0) {
      document.getElementById("clear-all-filters").style.display = "block";
    } else {
      document.getElementById("clear-all-filters").style.display = "none";
    }
    this.saveFiltersToSession();
    this.applyFilters();
  }

  addFilter(filterType, filterValue) {
    if (filterType.includes("Tier2")) this.handleTier2Selection();

    let currentFilterTag = "";
    const currentTagLowerCase =
      filterType.toLowerCase() + ":" + filterValue.toLowerCase();
    for (let i = 0; i < this._collectionTags.length; i++) {
      if (
        this.handleizeTag(this._collectionTags[i].toLowerCase()) ===
        this.handleizeTag(currentTagLowerCase)
      ) {
        currentFilterTag = this._collectionTags[i];
        break;
      }
    }
    if (!this._appliedFilters.includes(currentFilterTag)) {
      this._appliedFilters.push(currentFilterTag);
    }
  }

  removeFilter(fitlerType, filterValue) {
    let currentFilterTag = "";
    const currentTagLowerCase =
      fitlerType.toLowerCase() + ":" + filterValue.toLowerCase();
    for (let i = 0; i < this._collectionTags.length; i++) {
      if (
        this.handleizeTag(this._collectionTags[i].toLowerCase()) ===
        this.handleizeTag(currentTagLowerCase)
      ) {
        currentFilterTag = this._collectionTags[i];
        break;
      }
    }
    if (this._appliedFilters.includes(currentFilterTag)) {
      const index = this._appliedFilters.indexOf(currentFilterTag);
      this._appliedFilters.splice(index, 1);
    }
  }

  async handleTier2Selection() {
    this._isTier2Selected = true;
  }

  clearAllFilters() {
    this._appliedFilters = [];
    document.querySelectorAll(".filter-checkbox").forEach((checkbox) => {
      checkbox.checked = false;
    });
    document.getElementById("clear-all-filters").style.display = "none";
    this.saveFiltersToSession();
    this.applyFilters();
  }

  async applyFilters() {
    this.toggleLoading(true);
    const newProductGrid = await this.getFilteredProducts();
    this.renderProductList(newProductGrid);
    this.renderAppliedFilterTags();
    this.toggleLoading(false);
  }

  async processProductData(collectionHandle) {
    console.log("Processing product data");
    const hasFilters = this._appliedFilters.length > 0 || this._hasFitment;
    const isDefaultSort = this._currentSortBy.optionValue === "default";

    let concatenatedFilters = null;
    if (hasFilters) {
      concatenatedFilters = this._appliedFilters
        .map((filter) => this.handleizeTag(filter))
        .join("+");
    }

    console.log("Concatenated filters:", concatenatedFilters);

    try {
      if (hasFilters && isDefaultSort) {
        const products = await this.fetchProductData(
          collectionHandle,
          concatenatedFilters,
          null
        );

        console.log(
          "Filtered Products, first condition:",
          collectionHandle,
          concatenatedFilters
        );

        return sortBy(products, this._currentSortBy);
      } else if (hasFilters && !isDefaultSort) {
        const products = await this.fetchProductData(
          collectionHandle,
          concatenatedFilters,
          "title-ascending"
        );
        console.log("Filtered Products:", products);
        return products;
      } else if (!hasFilters) {
        const products = await this.fetchUnfilteredSortedProductData(
          collectionHandle,
          "title-ascending"
        );
        console.log("Unfiltered Products:", products);
        return products;
      } else {
        // Optional fallback case
        console.warn("Unhandled case in processProductData");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async fetchProductData(collectionHandle, concatenatedFilters, sortKey) {
    const url = sortKey
      ? `/collections/${collectionHandle}/${concatenatedFilters}?sort_by=title-ascending`
      : `/collections/${collectionHandle}/${await this.addConcatenatedUrlFitmentFilters(
          this._hasFitment,
          concatenatedFilters
        )}?sort_by=title-ascending`;

    console.log("URL:", url);

    try {
      const response = await fetch(url);
      if (!response.ok) {
        console.error("Fetch failed", response.status);
        return;
      }
      const data = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data;

      const newPaginationWrapper = tempDiv.querySelector(".pagination-wrapper");
      await this.handlePagination(newPaginationWrapper);

      return Array.from(
        tempDiv.querySelector("#main-collection-product-grid").children
      );
    } catch (error) {
      console.error(error);
    }
  }

  async fetchUnfilteredSortedProductData(collectionHandle, sortKey) {
    const url = !this._hasFitment
      ? `/collections/${collectionHandle}?sort_by=${sortKey}`
      : `/collections/${collectionHandle}/${await this.addConcatenatedUrlFitmentFilters(
          this._hasFitment,
          null
        )}?sort_by=${sortKey}`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        console.error("Fetch failed", response.status);
        return;
      }
      const data = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data;

      const newPaginationWrapper = tempDiv.querySelector(".pagination-wrapper");
      await this.handlePagination(newPaginationWrapper);

      return Array.from(
        tempDiv.querySelector("#main-collection-product-grid").children
      );
    } catch (error) {
      console.error(error);
    }
  }

  async addConcatenatedUrlFitmentFilters(hasFitment, concatenatedFilters) {
    const fitment = await JSON.parse(localStorage.getItem("fitmentData"))
      .currentVehicle;

    let handleized;

    // Concatenate the values dynamically
    let modifiedUrl = "";

    if (hasFitment) {
      handleized = Object.keys(fitment).reduce((acc, key) => {
        if (key !== "submodel") {
          acc[key] = fitment[key] ? this.handleizeTag(fitment[key]) : null;
        }
        return acc;
      }, {});

      const fitmentValues = Object.values(handleized).filter(Boolean).join("+");

      modifiedUrl = concatenatedFilters
        ? `${concatenatedFilters}+${fitmentValues}`
        : fitmentValues;
    } else {
      modifiedUrl = concatenatedFilters || "";
    }

    return hasFitment ? modifiedUrl : concatenatedFilters;
  }

  async handlePagination(newPaginationWrapper) {
    // Assign the newPaginationWrapper to state
    this._currentPaginationState.paginationWrapper = newPaginationWrapper;

    // Update visibility state based on whether newPaginationWrapper exists
    this._currentPaginationState.paginationIsVisible =
      Boolean(newPaginationWrapper);
  }

  async getFilteredProducts() {
    this.toggleLoading(true);
    try {
      const collectionHandle = window.location.pathname.split("/")[2];
      const sortedProducts = await this.processProductData(collectionHandle);

      const productUl = document
        .querySelector("#main-collection-product-grid")
        .cloneNode(false);
      sortedProducts.forEach((product) => {
        productUl.appendChild(product);
      });

      const newProductGrid = document.createElement("div");
      newProductGrid.appendChild(productUl);

      if (this._hasFitment) {
        await this.applyFitmentToProductData(newProductGrid);
      }

      this.toggleLoading(false);

      this.handleCollectionTagsUpdate();

      return newProductGrid;
    } catch (error) {
      console.error("Error getting filtered products: ", error);
    }
  }

  renderProductList(productHtml) {
    console.log("Rendering product list");
    const container = document.getElementById("collection-container");
    const productList = document.getElementById("main-collection-product-grid");
    const emptyMessage = document.getElementById("collection-empty-message");
    const noProductsMessage = document.getElementById(
      "collection-no-products-message"
    );
    const totalProducts = parseInt(container.dataset.totalProducts, 10);

    console.log("Total products in collection:", totalProducts);

    // Clear existing products
    productList.innerHTML = "";

    // Add filtered products
    const filteredProducts = productHtml.querySelectorAll(
      ".product-masonry-item"
    );

    const sortedProducts = Array.from(filteredProducts).sort((a, b) => {
      const aPrice = a.querySelector(".price-item");
      const bPrice = b.querySelector(".price-item");

      if (aPrice && bPrice) {
        const aPriceValue = parseFloat(
          aPrice.textContent.replace(/[^0-9.-]+/g, "")
        );
        const bPriceValue = parseFloat(
          bPrice.textContent.replace(/[^0-9.-]+/g, "")
        );

        return bPriceValue - aPriceValue;
      }
    });

    sortedProducts.forEach((product) => {
      productList.appendChild(product.cloneNode(true));
    });

    // Remove non-fitting products
    if (this._productsToRemove.length > 0) {
      this._productsToRemove.forEach((sku) => {
        this.removeNonFittingProduct(sku);
      });
      this._productsToRemove = [];
    }

    const visibleProducts = productList.querySelectorAll(
      ".product-masonry-item"
    ).length;

    console.log("Visible products after filtering:", visibleProducts);

    if (visibleProducts === 0) {
      productList.style.display = "none";
      if (totalProducts > 0) {
        // Show "use fewer filters" message
        console.log("Showing 'use fewer filters' message");
        emptyMessage.style.display = "block";
        noProductsMessage.style.display = "none";
      } else {
        // Show "no products" message
        console.log("Showing 'no products' message");
        emptyMessage.style.display = "none";
        noProductsMessage.style.display = "block";
      }
    } else {
      console.log("Showing product list");
      productList.style.display = "block";
      emptyMessage.style.display = "none";
      noProductsMessage.style.display = "none";
    }

    // Handle pagination
    const paginationWrapper = document.querySelector(".pagination-wrapper");
    if (paginationWrapper) {
      if (
        visibleProducts > 0 &&
        this._currentPaginationState.paginationIsVisible
      ) {
        paginationWrapper.style.display = "block";
        if (this._currentPaginationState.paginationWrapper) {
          paginationWrapper.innerHTML =
            this._currentPaginationState.paginationWrapper.innerHTML;
        }
      } else {
        paginationWrapper.style.display = "none";
      }
    }

    // Resize grid items
    this.resizeAllGridItems();

    // Update product count if applicable
    const productCountElement = document.querySelector(
      ".toolbar__product-count"
    );
    if (productCountElement) {
      productCountElement.textContent = `${visibleProducts} products`;
    }

    console.log("Finished rendering product list");
  }

  resizeAllGridItems() {
    const allItems = document.getElementsByClassName("product-masonry-item");
    for (let x = 0; x < allItems.length; x++) {
      this.resizeGridItem(allItems[x]);
    }
    const grid = document.getElementsByClassName("halo-row--masonry")[0];
    if (grid) {
      grid.classList.add("is-show");
    }
  }

  resizeGridItem(item) {
    const grid = document.getElementsByClassName("halo-row--masonry")[0];
    if (!grid) return;
    const rowHeight = parseInt(
      window.getComputedStyle(grid).getPropertyValue("grid-auto-rows")
    );
    const rowGap = parseInt(
      window.getComputedStyle(grid).getPropertyValue("grid-row-gap")
    );
    const rowSpan = Math.ceil(
      (item.querySelector(".product-item").getBoundingClientRect().height +
        rowGap) /
        (rowHeight + rowGap)
    );
    item.style.gridRowEnd = "span " + rowSpan;
  }

  renderAppliedFilterTags() {
    const tagsContainer = document.getElementById("applied-filter-tags");
    tagsContainer.innerHTML = ""; // Clear existing tags

    // Iterate through the applied filters
    this._appliedFilters.forEach((filter) => {
      // Strip the filter type and colon from the filter string
      const filterValue = filter.split(":")[1];
      // Create a div element for each tag
      const tagElement = document.createElement("div");
      tagElement.className = "applied-filter-tag";
      tagElement.textContent = filterValue;

      // Create a remove button for the tag
      const removeButton = document.createElement("button");
      removeButton.textContent = "x";
      removeButton.className = "remove-filter-button";

      // Attach the click event to the remove button
      removeButton.addEventListener("click", () => {
        const [filterType, filterValue] = filter.split(":");
        this.removeFilter(filterType, filterValue);

        // Find the corresponding checkbox
        const checkboxSelector = `.filter-checkbox[name='${filterType}'][value='${filterValue}']`;
        const correspondingCheckbox = document.querySelector(checkboxSelector);

        // Uncheck the checkbox
        if (correspondingCheckbox) {
          correspondingCheckbox.checked = false;
        }
        this.saveFiltersToSession();
        this.applyFilters();
      });

      tagElement.appendChild(removeButton);
      tagsContainer.appendChild(tagElement);
    });

    // Show "Clear Filters" link if there are any applied filters
    const clearAllFiltersLink = document.getElementById("clear-all-filters");
    if (this._appliedFilters.length > 0) {
      clearAllFiltersLink.style.display = "block";
    } else {
      clearAllFiltersLink.style.display = "none";
    }

    console.log("Filter data: ", this._filterData);
    console.log("Price data: ", this._priceData);

    // Hide the entire filter component if there are no available filters to apply
    const filterComponent = document.getElementById(
      "collection-attribute-sidebar"
    );
    const openButton = document.getElementById("open-sidebar");
    const hasAvailableFilters =
      Object.keys(this._filterData).length > 0 || this._priceData.length > 0;
  }

  async handleCollectionTagsUpdate() {
    this.toggleFilterLoading(true);
    const newTags =
      !this._hasFitment && this._appliedFilters.length === 0
        ? await this.getAllCollectionTags()
        : await this.getAllFilteredTags();
    this.updateCollectionTags(newTags);
  }

  async getAllCollectionTags() {
    try {
      let tagsFlat = [];
      let hasNextPage = true;
      let lastCursor = null;

      const collectionHandle = window.location.pathname.split("/").pop();

      console.log("This is the collection handle: ", collectionHandle);

      while (hasNextPage) {
        let afterCursor = lastCursor ? `, after: "${lastCursor}"` : "";
        let collectionQuery = `
          query {
            collectionByHandle(handle: "${collectionHandle}") {
              products(first: 250${afterCursor}) {
                pageInfo {
                  hasNextPage
                }
                edges {
                  cursor
                  node {
                    tags
                  }
                }
              }
            }
          }`;

          console.log("Collection query:", collectionQuery);

        const response = await makeGraphQLRequest(collectionQuery);

        if (!response || !response.data) {
          throw new Error("Invalid response from the server");
        }

        console.log("Response:", response);

        hasNextPage =
          response.data.collectionByHandle.products.pageInfo.hasNextPage;
        const edges = response.data.collectionByHandle.products.edges;

        if (edges.length > 0) {
          lastCursor = edges[edges.length - 1].cursor;

          const tags = edges.map((edge) => edge.node.tags);
          tagsFlat = tagsFlat.concat(tags.flat());
        } else {
          hasNextPage = false;
        }
      }

      return tagsFlat;
    } catch (error) {
      console.error("Error getting collection tags: ", error);
      return [];
    }
  }
  async getAllFilteredTags() {
    let tags = [];

    // Check if there's a valid fitment
    if (
      !this._hasFitment ||
      !this._currentFitment ||
      Object.keys(this._currentFitment).length === 0
    ) {
      // If no valid fitment, just use the applied filters
      const query = `query {
        products(first: 250${this.buildTagFilterQuery()}) {
          edges {
            node {
              tags
            }
          }
        }
      }`;

      const response = await makeGraphQLRequest(query);
      tags = response.data.products.edges.map((edge) => edge.node.tags).flat();

      console.log("Query:", query);
      console.log("Filtered tags:", tags);
    } else {
      // If there's a valid fitment, we need to check each product's metafield
      const query = `query {
        products(first: 250${this.buildTagFilterQuery()}) {
          edges {
            node {
              tags
              variants(first:1) {
                edges {
                  node {
                    metafield(namespace:"pim", key:"fitment_details") {
                      value
                      type
                    }
                  }
                }
              }
            }
          }
        }
      }`;

      const response = await makeGraphQLRequest(query);

      for (const edge of response.data.products.edges) {
        const product = edge.node;
        if (product.variants && product.variants.edges.length > 0) {
          const productMetafield = product.variants.edges[0].node.metafield;

          if (productMetafield) {
            const productMatched = isSubmodelMatch(
              productMetafield.value,
              this._currentFitment
            );
            if (productMatched) {
              tags = tags.concat(product.tags);
            }
          } else {
            // If no metafield, include the product's tags
            tags = tags.concat(product.tags);
          }
        }
      }
    }

    console.log("Filtered tags:", tags);

    // Remove duplicates and return
    return [...new Set(tags)];
  }

  buildTagFilterQuery() {
    const collectionMap = {
      "shocks-coil-overs": "Shocks & Coil-Overs",
      "coil-overs": "Coil-Overs",
      "tools-accessories": "Tools & Accessories",
    };
    const appliedFilters = this._appliedFilters;
    let newQueryParam = "";
    let hasReturnedCollectionHandle = false;

    if (!this._hasFitment && appliedFilters.length > 0) {
      newQueryParam = getFilterQuery(appliedFilters);
    } else if (this._hasFitment && appliedFilters.length === 0) {
      newQueryParam = `${manageTier2(
        appliedFilters
      )} AND ${applyFitmentToTagQuery(this._currentFitment)}`;
    } else if (this._hasFitment && appliedFilters.length > 0) {
      newQueryParam = getFilterQuery(appliedFilters);

      // Add fitment query to the tag query
      newQueryParam += ` AND ${applyFitmentToTagQuery(this._currentFitment)}`;
    }

    function getFilterQuery(filters) {
      return filters
        .map((filter) => {
          const tier2Filter = manageTier2(filters, filter);
          return tier2Filter
            ? tier2Filter + ` AND tag:'${filter.replace(/"/g, '\\"')}'`
            : `tag:'${filter.replace(/"/g, '\\"')}'`;
        })
        .filter(Boolean)
        .join(" AND ");
    }

    function manageTier2(appliedFilters) {
      const collectionHandle = window.location.pathname.split("/")[2];
      const tier2Applied = appliedFilters.some((filter) =>
        filter.toLowerCase().includes("tier2")
      );

      if (tier2Applied || hasReturnedCollectionHandle) {
        return null;
      }

      const result =
        collectionMap[collectionHandle] ||
        formatCollectionHandle(collectionHandle);

      if (result) {
        hasReturnedCollectionHandle = true;
      }

      return `tag:'${result}'`;
    }

    function applyFitmentToTagQuery(currentFitment) {
      const fitment = currentFitment;
      if (!fitment || Object.keys(fitment).length === 0) {
        return ""; // Return empty string if no fitment or empty fitment
      }
      const fitmentQueryParams = Object.entries(fitment)
        .map(([key, value]) => (value ? `tag:'${value}'` : null))
        .filter(Boolean);

      const fitmentQuery = fitmentQueryParams
        .join(" AND ")
        .replace(/"/g, '\\"');

      return fitmentQuery;
    }

    function formatCollectionHandle(handle) {
      return handle
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }

    return newQueryParam ? `, query: "${newQueryParam}"` : "";
  }

  async updateCollectionTags(newTags) {
    try {
      let tags = [];
      newTags.forEach((tag) => {
        if (!tags.includes(tag)) {
          tags.push(tag);
        }
      });
      // Update the collection tags
      this._collectionTags = tags;
      await this.resetAndRebuildFilters(this._collectionTags);
      this.toggleFilterLoading(false);
    } catch (error) {
      console.error("Error updating collection tags: ", error);
    }
  }

  async applyFitmentToProductData(productDataHtml) {
    console.log("Applying fitment to product data");
    console.log("Product data:", productDataHtml);
    console.log("Current fitment:", this._currentFitment);

    const currentFitment = this._currentFitment;
    if (!currentFitment || Object.keys(currentFitment).length === 0) {
      console.log("No fitment data, skipping fitment application");
      return;
    }

    const elements = productDataHtml.querySelectorAll(
      "#main-collection-product-grid li > div"
    );
    console.log("Number of products to process:", elements.length);

    let variantSkuList = [];

    elements.forEach((element) => {
      const variantObj = parseVariantData(element);
      variantSkuList.push(variantObj);
    });

    for (let i = 0; i < variantSkuList.length; i++) {
      const product = variantSkuList[i];
      console.log("Processing product:", product);

      const query = generateProductQuery(product.variantSku);
      const response = await makeGraphQLRequest(query);

      console.log("Product response:", response.data.products.edges);

      const filteredProductData = this.filterProductByVariantSku(
        response,
        product.variantSku
      );

      let productMetafield;
      // Check if the metafield exists at the product level or variant level
      if (
        filteredProductData.length > 0 &&
        filteredProductData[0].node.metafield
      ) {
        productMetafield = filteredProductData[0].node.metafield.value;
      } else if (
        filteredProductData.length > 0 &&
        filteredProductData[0].node.variants.edges[0].node.metafield
      ) {
        productMetafield =
          filteredProductData[0].node.variants.edges[0].node.metafield.value;
      }

      // Handle the product metafield and tags
      this.handleProductMetafieldAndTags(product, productMetafield, response);
    }

    console.log(
      "Finished applying fitment. Products to remove:",
      this._productsToRemove
    );
  }

  filterProductByVariantSku(productsResponse, variantSku) {
    return productsResponse.data.products.edges.filter(
      (edge) => edge.node.variants.edges[0].node.sku === variantSku
    );
  }

  handleProductMetafieldAndTags(product, productMetafield, response) {
    console.log("Handling product metafield and tags for:", product);

    let productsNotMatching = 0;
    const currentFitment = this._currentFitment;
    if (!currentFitment || Object.keys(currentFitment).length === 0) {
      console.log("No fitment data, skipping product handling");
      return productsNotMatching;
    }

    console.log("Product's metafield:", productMetafield);

    const productMatched = productMetafield
      ? isSubmodelMatch(productMetafield, currentFitment)
      : null;

    console.log("Product matched:", productMatched);

    if (productMatched === false && productMatched !== null) {
      productsNotMatching++;
      this._productsToRemove.push(product.variantSku);
      console.log(
        "Product doesn't match fitment, added to remove list:",
        product.variantSku
      );
    }

    if (this._appliedFilters.length > 0) {
      const resTags = response.data.products.edges.map(
        (edge) => edge.node.tags
      );
      const resTagsFlat = resTags.flat();
      resTagsFlat.forEach((tag) => {
        if (!this._filterCollectionTags.includes(tag)) {
          this._filterCollectionTags.push(tag);
        }
      });
    }

    return productsNotMatching;
  }

  removeNonFittingProduct(sku) {
    const elements = document.querySelectorAll(
      "#main-collection-product-grid li > div"
    );

    elements.forEach((element) => {
      const variantObjSku = parseVariantData(element).variantSku;
      if (variantObjSku === sku) {
        element.parentElement.remove();
      }
    });
    return;
  }

  toggleLoading(show) {
    const loadingOverlay = document.querySelector(".loading-overlay--custom");
    if (show) {
      loadingOverlay.style.display = "block";
    } else {
      loadingOverlay.style.display = "none";
    }
  }

  toggleFilterLoading(show) {
    const loadingDiv = `<div id="js-loading-div" class="loading-overlay loading-overlay--custom" style="display: block;">
                    <div class="loading-overlay__spinner" aria-label="{{ 'general.button_load_more.loading' | t }}"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>
                </div>`;
    const tagsDiv = document.getElementById("tags");
    if (show) {
      tagsDiv.insertAdjacentHTML("afterbegin", loadingDiv);
    }
  }

  toTitleCase(str) {
    return str
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2") // Insert space before each capital letter
      .replace(/(\b[a-z](?!\s))/g, (x) => x.toUpperCase()); // Capitalize the first letter of each word
  }

  handleizeTag(input) {
    return input
      .toLowerCase() // Convert to lowercase
      .replace(/:/g, "-") // Replace colons with hyphens
      .replace(/\./g, "-") // Replace periods with hyphens
      .replace(/[^a-z0-9-\s]/g, "") // Remove characters that are not alphanumeric, spaces, or hyphens
      .replace(/\s+/g, "-") // Replace spaces with hyphens
      .replace(/-+/g, "-") // Replace multiple hyphens with a single hyphen
      .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
  }

  setLoadingState() {
    this._sidebar.classList.add("loading");
  }

  saveFiltersToSession() {
    const state = {
      selectedPriceRange: this._selectedPriceRange,
      appliedFilters: this._appliedFilters,
      currentSortBy: this._currentSortBy.optionValue,
    };
    sessionStorage.setItem(
      `fitlers-${window.location.pathname.split("/")[2]}`,
      JSON.stringify(state)
    );
  }

  loadFiltersFromSession() {
    const savedState = sessionStorage.getItem(
      `fitlers-${window.location.pathname.split("/")[2]}`
    );

    if (savedState) {
      const state = JSON.parse(savedState);
      this._selectedPriceRange = state.selectedPriceRange || { min: 0, max: 0 };
      this._appliedFilters = state.appliedFilters || [];
      this._currentSortBy.optionValue =
        state.currentSortBy.optionValue || "default";

      // Restore checkboxes based on the applied filters
      this.setAppliedFacetFiltersChecked();

      this.applyFilters();

      // Show/Hide clear all filters button based on the applied filters
      if (this._appliedFilters.length > 0) {
        document.getElementById("clear-all-filters").style.display = "block";
      } else {
        document.getElementById("clear-all-filters").style.display = "none";
      }
    } else if (!savedState) {
      this.saveFiltersToSession();
      this.applyFilters();
    }
  }

  setAppliedFacetFiltersChecked() {
    this._appliedFilters.forEach((filterTag) => {
      const [filterType, filterValue] = filterTag.split(":");
      const checkboxSelector = `.filter-checkbox[name='${this.toTitleCase(
        filterType
      )}'][value='${filterValue}']`;
      const checkboxElement = document.querySelector(checkboxSelector);
      if (checkboxElement) {
        checkboxElement.checked = true;
      }
    });
  }

  bindCheckboxEvents() {
    document.querySelectorAll(".filter-checkbox").forEach((checkbox) => {
      checkbox.addEventListener("change", (event) =>
        this.handleFilterChange(event)
      );
    });
  }
}

const collectionAttributeSidebar = new CollectionAttributeSidebar(
  collectionTags
);

// Helper functions
function sortBy(products, currentSortBy) {
  switch (currentSortBy.optionValue) {
    case "low-to-high":
      return products.sort((a, b) => {
        const priceA = parseFloat(
          a
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        const priceB = parseFloat(
          b
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        return priceA - priceB;
      });
    case "high-to-low":
      return products.sort((a, b) => {
        const priceA = parseFloat(
          a
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        const priceB = parseFloat(
          b
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        return priceB - priceA;
      });
    case "alpha-asc":
      return products.sort((a, b) => {
        const titleA = a.querySelector(".card-title").textContent.trim();
        const titleB = b.querySelector(".card-title").textContent.trim();
        return titleA.localeCompare(titleB);
      });
    case "alpha-desc":
      return products.sort((a, b) => {
        const titleA = a.querySelector(".card-title").textContent.trim();
        const titleB = b.querySelector(".card-title").textContent.trim();
        return titleB.localeCompare(titleA);
      });
    default:
      return products;
  }
}

function parseVariantData(element) {
  const jsonData = element.getAttribute("data-json-product");
  const decodedStr = decodeURIComponent(jsonData);
  const parsedObj = JSON.parse(decodedStr);
  return {
    productTitle: parsedObj.variants[0].name,
    variantSku: parsedObj.variants[0].sku,
  };
}

function generateProductQuery(variantSku) {
  return `query {
            products(first:1, query: "${variantSku}") {
              edges {
                node {
                  title
                  tags
                  variants(first:1) {
                    edges {
                      node {
                        metafield(namespace:"pim", key:"fitment_details") {
                          value
                          type
                        }
                      }
                    }
                  }
                }
              }
            }
          }`;
}

async function makeGraphQLRequest(query) {
  const response = await fetch(
    "https://jks-development.myshopify.com/api/2024-07/graphql.json",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "1f9a6d6405766e9165393f8748125cfc",
      },
      body: JSON.stringify({ query }),
    }
  );
  const json = await response.json();
  return json;
}

function isSubmodelMatch(fitmentStrings, fitmentSelection) {
  const { year, make, model, submodel, drive_type, fuel_type } =
    fitmentSelection;

  function stringToObject(fitmentStrings) {
    return fitmentStrings.split(";").map((str) => {
      const [year, make, model, sub_model, drive_type, fuel_type] =
        str.split("|");
      return { year, make, model, sub_model, drive_type, fuel_type };
    });
  }

  function isMatch(fitmentValue, inputValue, wildcard = "*") {
    return (
      inputValue &&
      fitmentValue &&
      (fitmentValue.toLowerCase() === inputValue.toLowerCase() ||
        fitmentValue.toLowerCase() === wildcard)
    );
  }

  const fitmentStringArray = stringToObject(fitmentStrings);
  let isSubModelMatch = false;

  for (const fitment of fitmentStringArray) {
    const yearMatch = fitment.year === year;
    const makeMatch = isMatch(fitment.make, make);
    const modelMatch = isMatch(fitment.model, model);
    const driveTypeMatch = isMatch(fitment.drive_type, drive_type);
    const fuelTypeMatch = isMatch(fitment.fuel_type, fuel_type);
    const submodelMatch = isMatch(fitment.sub_model, submodel);

    // Check if all fields match (considering 'X' as wildcard for submodel)
    if (
      yearMatch &&
      makeMatch &&
      modelMatch &&
      (driveTypeMatch || driveTypeMatch === undefined) &&
      (fuelTypeMatch || fuelTypeMatch === undefined) &&
      (submodelMatch || submodelMatch === undefined)
    ) {
      isSubModelMatch = true;
      break;
    }
  }

  return isSubModelMatch;
}

// Open sidebar externally
function toggleFilterSidebar() {
  const sidebar = document.getElementById("collection-attribute-sidebar");
  if (sidebar.classList.contains("filter-sidebar-open")) {
    sidebar.classList.remove("filter-sidebar-open");
  } else {
    sidebar.classList.add("filter-sidebar-open");
  }
}
